import { render, staticRenderFns } from "./UserBizRecordDialog.vue?vue&type=template&id=68d09fb9"
import script from "./UserBizRecordDialog.vue?vue&type=script&lang=js"
export * from "./UserBizRecordDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports